/**
 * 学习乐园 · 连连看题材包：图案记忆（lianliankan/pack-tuan.js）
 * ---------------------------------------------------------------------------
 * 相同型配对（kind 'same'）：左右牌面一样，同图案消除——传统连连看玩法，
 * 练的是瞬时记忆与观察。牌面用系统 emoji（零图片文件、零请求）；各平台
 * emoji 长相略有差异，页内 doc 已如实说明。24 种图案抽 18 对开局，
 * 每局组合不同。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  var FACES = [
    '🍎', '🍐', '🍊', '🍋', '🍉', '🍇',
    '🍓', '🍒', '🍑', '🥭', '🍍', '🥕',
    '🐱', '🐶', '🐰', '🦊', '🐻', '🐼',
    '🐮', '🐷', '🐸', '🐵', '🐔', '🦉'
  ];

  var pairs = [];
  for (var i = 0; i < FACES.length; i++) {
    pairs.push({ l: FACES[i], r: FACES[i] });
  }

  PACKS.tuan = {
    id: 'tuan',
    name: '图案记忆',
    hint: '同图案消除，练眼力',
    kind: 'same',
    cols: 6,
    rows: 6,
    pairs: pairs
  };
})(typeof window !== 'undefined' ? window : globalThis);
